export const TermsAndConditions = ({htmlFor = 'term'}) => {
	return (
		<label className={'text-term leading-3'} htmlFor={htmlFor}>
			He leído y acepto las <a href="https://lomasdecarabayllo.pe/Politica-de-privacidad-de-datos.pdf" target="_blank">Políticas de Privacidad</a>
		</label>
	);
};
